











































































import { Component, Vue, Watch } from 'vue-property-decorator'
import PageHeader from '@/views/browse-and-go/components/PageHeader.vue'
import { audienceLabel, cloneData, formatDuration } from '@/services/browse-and-go/labels'
import { bngState, deleteOperation, findOperation, saveOperation } from '@/services/browse-and-go/store'
import { OperationModel } from '@/services/browse-and-go/types'

function blankOperation(): OperationModel {
  return {
    id: '',
    name: '',
    family: 'OTHER',
    code: '',
    defaultDurationMonths: 12,
    defaultAudience: 'NONE',
    collectsChildIdentity: false,
    builtin: false
  }
}

@Component({
  name: 'BrowseAndGoOperationEdit',
  components: { PageHeader }
})
export default class extends Vue {
  private draft: OperationModel = blankOperation()
  private ready = false
  private audienceLabel = audienceLabel

  get isCreate() {
    return this.$route.name === 'BrowseAndGoOperationCreate'
  }

  get durationLabel() {
    return formatDuration(this.draft.defaultDurationMonths || 0)
  }

  @Watch('$route.fullPath', { immediate: true })
  private load() {
    if (this.isCreate) {
      this.draft = blankOperation()
      this.ready = true
      return
    }
    const operation = findOperation(String(this.$route.params.id || ''))
    if (!operation) {
      this.$message.error('Modèle d\'opération introuvable')
      this.$router.replace({ name: 'BrowseAndGoOther' })
      return
    }
    this.draft = cloneData(operation)
    this.ready = true
  }

  private returnName() {
    if (this.draft.family === 'URSSAF') return 'BrowseAndGoUrssaf'
    return 'BrowseAndGoOther'
  }

  private cancel() {
    this.$router.push({ name: this.returnName() })
  }

  private save() {
    const name = this.draft.name.trim()
    if (!name) {
      this.$message.error('Le nom est obligatoire')
      return
    }
    this.draft.name = name
    if (this.draft.builtin) {
      const original = bngState.operations.find(operation => operation.id === this.draft.id)
      if (original) this.draft.defaultAudience = original.defaultAudience
    }
    saveOperation(this.draft)
    this.$message.success('Modèle d\'opération enregistré')
    this.$router.push({ name: this.returnName() })
  }

  private remove() {
    this.$confirm(
      'Supprimer ce modèle d\'opération et ses modèles de carte multi-choix ?',
      'Supprimer',
      { type: 'warning', confirmButtonText: 'Supprimer', cancelButtonText: 'Annuler' }
    ).then(() => {
      deleteOperation(this.draft.id)
      this.$message.success('Modèle d\'opération supprimé')
      this.$router.push({ name: 'BrowseAndGoOther' })
    }).catch(() => undefined)
  }
}
